<template>
	<az-dialog>
		<v-data-table
			:headers="[]"
			:items="[]"
			hide-actions
			class="elevation-1"
			select-all
			item-key="id"
			:loading="true"
		>
		</v-data-table>
	</az-dialog>
</template>

<script>
	import AzDialog from "../components/dialogs/AzDialog.vue";

	export default {
		props: {

		},

		data() {
			return {

			}
		},

		components: {
			AzDialog
		}
	}
</script>